export const AUTO_NO_SHOW_REASON = 'Automatically created no-show due to missed scheduled shift.';

export function isAutoNoShowAbsence(absence: {
  absenceType?: string | null;
  reason?: string | null;
} | null | undefined): boolean {
  if (!absence) return false;
  return (
    absence.absenceType === 'no_show'
    && (absence.reason === AUTO_NO_SHOW_REASON
      || Boolean(absence.reason?.includes('Automatically created no-show')))
  );
}

export function getAbsenceLabel(absence: {
  absenceType?: string | null;
  reason?: string | null;
}): string {
  if (isAutoNoShowAbsence(absence)) {
    return 'missed shift (no-show)';
  }
  return absence.reason || absence.absenceType || 'absence';
}
